import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Lots.frontend.types'

@Injectable({ providedIn: 'root' })
export class Lots_is_lot_deletableService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { lotIds?: number[], vendorLotIds?: number[] }): Promise<{ lotIds?: number[], vendorLotIds?: number[], exceptions?: { type?: string, id?: number, reason?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Lots/functions/is_lot_deletable`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

